import { useBrandTerminology } from './useBrandTerminology';

type TaskType = 'foundational' | 'growth' | 'recurring';
type TerminologyOptions = { plural?: boolean };

export const useTaskTerminology = () => {
  const { getTerminology } = useBrandTerminology();

  const getTaskTypeName = (taskType: TaskType, options: TerminologyOptions = {}): string => {
    const { plural = false } = options;
    const technicalTerm = `${taskType}_tasks` as any;
    return getTerminology(technicalTerm, { plural });
  };

  const getSourceTypeName = (sourceType: string | undefined): string => {
    if (!sourceType) return 'Manual';
    
    // Handle special case for recurring_rule
    if (sourceType === 'recurring_rule') {
      return 'Recurring Rule';
    }
    
    // Map source_type to technical_term (e.g., 'my_own_initiative' -> 'source_my_own_initiative')
    const technicalTerm = `source_${sourceType}` as any;
    
    // Get custom terminology or fallback to formatted version
    return getTerminology(technicalTerm, { 
      fallback: sourceType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) 
    });
  };

  return { getTaskTypeName, getSourceTypeName };
};
